import api from './api';

export interface BusinessUnit {
  id: number;
  name: string;
  code: string;
  location: string;
  description: string;
  isActive: boolean;
}

export const businessUnitService = {
  getAll: () => api.get<BusinessUnit[]>('/businessunits'),
  
  search: (search?: string, limit: number = 20) =>
    api.get<BusinessUnit[]>('/businessunits/search', { params: { search, limit } }),
  
  getById: (id: number) => api.get<BusinessUnit>(`/businessunits/${id}`),
  
  create: (data: Omit<BusinessUnit, 'id' | 'isActive'>) =>
    api.post<BusinessUnit>('/businessunits', data),
  
  update: (id: number, data: Omit<BusinessUnit, 'id' | 'isActive'>) =>
    api.put<BusinessUnit>(`/businessunits/${id}`, data),
  
  delete: (id: number) =>
    api.delete(`/businessunits/${id}`),
};
